import { cn } from '@/lib/utils'
import { getStatusColor } from '@/lib/utils'

interface BadgeProps {
  label?: React.ReactNode
  children?: React.ReactNode
  status?: string
  variant?: 'success' | 'warning' | 'error' | 'info' | 'muted' | 'primary' | 'ai'
  size?: 'sm' | 'md'
  dot?: boolean
  className?: string
}

const variantClasses = {
  success: 'bg-success/15 text-success border-success/30',
  warning: 'bg-warning/15 text-warning border-warning/30',
  error: 'bg-error/15 text-error border-error/30',
  info: 'bg-info/15 text-info border-info/30',
  muted: 'bg-muted/15 text-muted border-muted/30',
  primary: 'bg-primary/15 text-primary border-primary/30',
  ai: 'bg-ai/15 text-ai-light border-ai/30',
}

export function Badge({ label, children, status, variant, size = 'sm', dot, className }: BadgeProps) {
  const resolvedVariant = variant ?? (status ? (getStatusColor(status) as BadgeProps['variant']) : 'muted')
  const v = resolvedVariant ?? 'muted'

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm',
        variantClasses[v],
        className
      )}
    >
      {dot && (
        <span className={cn('w-1.5 h-1.5 rounded-full', {
          'bg-success': v === 'success',
          'bg-warning': v === 'warning',
          'bg-error': v === 'error',
          'bg-info': v === 'info',
          'bg-muted': v === 'muted',
          'bg-primary': v === 'primary',
          'bg-ai': v === 'ai',
        })} />
      )}
      {children || label}
    </span>
  )
}
